import React from "react";
import ShopifySVG from "../../../../assets/svg/shopify.svg";
import Modal from "../../../../components/common/Modal";

const ShopifyBlogIdGuideModal = ({
  onRequestClose,
}: {
  onRequestClose: () => void;
}) => {
  return (
    <Modal
      maxWidth={700}
      width={700}
      onRequestClose={onRequestClose}
      isOpen={true}
    >
      <div className="max-w-3xl px-4 pt-4 pb-6 md:px-8 md:pt-8 md:pb-10">
        <div className="flex items-center gap-3 mb-4">
          <img
            alt="shopify-logo"
            src={ShopifySVG}
            width={40}
            height={40}
          />
          <h2 className="text-xl font-semibold">Find Your Shopify Blog ID</h2>
        </div>

        <p className="mb-4">
          To publish articles with ArticleX, you'll need the ID of the blog
          where the article should be posted.
        </p>

        <ol className="list-decimal list-inside space-y-2">
          <li>Log in to your Shopify admin dashboard.</li>
          <li>
            In the left-hand menu, click <strong>Content</strong> &gt;{" "}
            <strong>Blog posts</strong>.
          </li>
          <li>
            Click on the <strong>Manage blogs</strong> button.
          </li>
          <li>
            Click on the blog you'd like to post to (e.g., <em>News</em>).
          </li>
          <li>
            Look at the URL in your browser. It will look like:
            <pre className="bg-gray-100 p-2 rounded text-sm text-wrap my-1">
              https://admin.shopify.com/store/your-store/content/blogs/1234567890
            </pre>
          </li>
          <li>
            The number at the end (<code>1234567890</code>) is your{" "}
            <strong>Blog ID</strong>.
          </li>
          <li>
            Copy and paste this Blog ID into the <strong>Blog ID</strong> field
            in ArticleX.
          </li>
        </ol>
      </div>
    </Modal>
  );
};

export default ShopifyBlogIdGuideModal;
